import { css } from '@emotion/react'
import { ModalBody, Theme, useTheme } from 'bold-ui'
import { ResponsiveModal } from 'components/responsive'
import { useEffect } from 'react'

import { ChatMessage, SUPPORTS_VIRTUAL_KEYBOARD } from '../model-videochamada'
import { ChatVideochamada, ChatVideochamadaProps } from './ChatVideochamada'

declare global {
  interface VirtualKeyboard {
    overlaysContent: boolean
  }

  interface Navigator {
    readonly virtualKeyboard?: VirtualKeyboard
  }
}

interface ChatVideochamadaMobileModalProps extends ChatVideochamadaProps {
  open: boolean
  messages: ChatMessage[]
  onClose?(): void
  onSendMessage(message: string): void
  messageInput: string
  onChangeInput(message: string): void
}

export function ChatVideochamadaMobileModal(props: ChatVideochamadaMobileModalProps) {
  const { open, messages, onClose, onSendMessage, messageInput, onChangeInput, ...rest } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  useEffect(() => {
    if (SUPPORTS_VIRTUAL_KEYBOARD) navigator.virtualKeyboard.overlaysContent = true

    return () => {
      if (SUPPORTS_VIRTUAL_KEYBOARD) navigator.virtualKeyboard.overlaysContent = false
    }
  }, [])

  return (
    <ResponsiveModal
      open={open}
      onClose={onClose}
      size='large'
      style={styles.chatModalMobile}
      wrapperStyle={styles.parentChatModalMobile}
      backdropStyle={styles.backdropChatModalMobile}
    >
      <ModalBody style={styles.chatModalBodyMobile}>
        <ChatVideochamada
          open={open}
          messages={messages}
          onClose={onClose}
          onSendMessage={onSendMessage}
          isMobile
          messageInput={messageInput}
          onChangeInput={onChangeInput}
          {...rest}
        />
      </ModalBody>
    </ResponsiveModal>
  )
}

const createStyles = (theme: Theme) => ({
  parentChatModalMobile: css`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows:
      1fr
      env(keyboard-inset-height, 0px);
  `,
  backdropChatModalMobile: css`
    background-color: ${theme.pallete.gray.c10};
  `,
  chatModalMobile: css`
    background-color: ${theme.pallete.gray.c10};
    min-width: 0;
    border: 0;
    border-radius: 0 !important;
  `,
  chatModalBodyMobile: css`
    height: 100%;
    padding: 1rem 0;
  `,
})
